import React, { useMemo, useState } from "react";
import { IntlContext } from "./IntlContext";
import { defaultLang } from "../constants";

export const IntlProvider = ({
  children,
  initialLang = defaultLang,
  initialPageLangVariants = null,
}) => {
  const [lang, setLang] = useState(initialLang);
  const [pageLangVariants, setPageLangVariants] = useState(
    initialPageLangVariants,
  );

  const contextValue = useMemo(
    () => ({
      lang,
      setLang,
      pageLangVariants,
      setPageLangVariants,
    }),
    [lang, setLang, pageLangVariants, setPageLangVariants],
  );

  return (
    <IntlContext.Provider value={contextValue}>{children}</IntlContext.Provider>
  );
};
